'use client';

import { useTranslations } from 'next-intl';
// import { RegistrationMetrics } from './registration-metrics';
import { RegistrationListing } from './registration-listing';

export function RegistrationPageContent() {
  const t = useTranslations('registration');

  return (
    <div className='space-y-6'>
      <h1 className='text-2xl font-bold tracking-tight'>{t('pageTitle')}</h1>
      {/* <RegistrationMetrics /> */}
      <RegistrationListing />
    </div>
  );
}
